// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2-7fV","inputDescription":"styles_inputDescription__atyNs"};